import React, { Component } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { Link,withRouter   } from "react-router-dom"

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export class Navbar extends Component {
  constructor(props) {
    super(props);
    console.log("Initial state - ", this.state);
  }

  render() {
    const pages_navbar = {
      home: [{ text: "Hi " + this.props.name, link: "/home" }],
      profile: [{ text: "Profile", link: "/profile" }],
      money: [{ text: "accounts", link: "/money" }, { text: "investments", link: "/money/investments" }],
      spending: [{ text: "spending", link: "/spending" }, { text: "budget", link: "/spending/budget" }],
      carbon_footprint: [{ text: "carbon footprint", link: "/carbon-footprint" }, { text: "take action", link: "/carbon-footprint/take-action" }]
    };

    return (
      <Box component="main" className="navbar">
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
          value={this.props.path}
            // value={this.state.value}
            sx={{
              "& .MuiTabs-flexContainer": {
                justifyContent: "space-around",
               height:{xs:"50px",md:"70px"}
              },
            }}
          >
            {pages_navbar[this.props.page].map((navbarButton, index) => (
              <Tab
              key={index}
              value={navbarButton.link}
              sx={{ fontWeight: 800, letterSpacing:"0.01rem", fontSize:"medium" }}
                label={navbarButton.text}
                component={Link}
                to={navbarButton.link}
                {...a11yProps(index)}
              />
            ))}
          </Tabs>
        </Box>
      </Box>
    );
  }
}

export default withRouter(Navbar);